import { Box, makeStyles, TextField } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { editBgImage } from 'src/store/modules/imageUpload';
import { RootState, useSelector } from 'src/store';
import AboutImageTooltip from 'src/components/AboutIamgeTooltip';

interface editBgImageProps {
  menuTitle: string;
  type: string;
}

const MultiEditBgImage: FC<editBgImageProps> = ({ menuTitle, type }) => (
  <div style={{ padding: '20px 16px' }}>
    <div
      style={{
        marginBottom: '16px',
        fontSize: '13px',
        fontWeight: 600,
        fontFamily: "'Poppins', sans-serif",
        color: '#191F28',
        letterSpacing: '0.02em',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      {menuTitle}
      <AboutImageTooltip />
    </div>

    <div
      style={{
        padding: '12px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        border: '1px solid #E5E8EB',
        borderRadius: '8px',
        backgroundColor: '#F7F8FA'
      }}
    >
      <MultiBgImage type={type} />
    </div>
  </div>
);

export default MultiEditBgImage;

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
    height: '100px',
    outline: 'none',
    overflow: 'overlay',
    '&:focus': {
      border: 0,
      outline: 'none'
    }
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '1.5',
    color: '#191F28'
  }
}));
export const MultiBgImage = ({ type }: any) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);

  const handleImageInput = () => {
    document.getElementById('imageInput').click();
  };

  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(bgImage?.[type]?.[currentIndex]);
  }, [currentIndex, bgImage]);

  const handleChange = event => {
    setUrl(event.target.value);
    const newImage = [...bgImage?.[type]];

    newImage[currentIndex] = event.target.value
      .replace(/"/g, "'")
      .replace(/\n/g, '');

    const newBgImage = {
      [type]: newImage?.map((_: any, idx: number) => `${newImage?.[idx]}`)
    };

    dispatch(editBgImage({ ...bgImage, ...newBgImage }));
  };

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row'
      }}
    >
      <div
        onClick={handleImageInput}
        style={{
          width: '100%',
          height: '100px',
          padding: 0,
          cursor: 'pointer',
          color: '#191F28',
          display: 'flex',
          fontFamily: "'Poppins', sans-serif",
          fontSize: '13px',
          fontWeight: 400
        }}
      >
        <TextField
          id="imageInput"
          multiline
          value={url}
          onChange={handleChange}
          // onKeyPress={handleKey}
          className={classes.input}
          placeholder="Please embed image URL"
          InputProps={{
            classes: {
              root: classes.inputRoot,
              input: classes.inputText
            },
            disableUnderline: true
          }}
        />
      </div>
    </Box>
  );
};
